module.exports = __webpack_public_path__ + "img/30-2-bg.0740865b.png";